import React from 'react';
import PropTypes from 'prop-types';

export default function Logo(props) {
  const { path } = props;
  return <img src={path} alt="logo" {...props} />;
}

Logo.propTypes = {
  path: PropTypes.string.isRequired,
};
